import { render, staticRenderFns } from "./layout-gallery-main.vue?vue&type=template&id=1989a3b8"
import script from "./layout-gallery-main.vue?vue&type=script&lang=js"
export * from "./layout-gallery-main.vue?vue&type=script&lang=js"
import style0 from "./layout-gallery-main.vue?vue&type=style&index=0&id=1989a3b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports